/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bonus_RewardsInputs */

const en_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus Rewards!`)
};

const ar_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكافآت إضافية!`)
};

const de_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonusbelohnungen!`)
};

const es_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Recompensas extra!`)
};

const fr_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récompenses bonus !`)
};

const it_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricompense bonus!`)
};

const ja_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボーナス報酬！`)
};

const ko_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보너스 보상!`)
};

const pt_br_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas bônus!`)
};

const ru_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бонусные награды!`)
};

const th_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลโบนัส!`)
};

const tr_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus ödüller!`)
};

const zh_cn_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加码奖励！`)
};

const zh_tw_bonus_rewards = /** @type {(inputs: Bonus_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加碼獎勵！`)
};

/**
* | output |
* | --- |
* | "Bonus Rewards!" |
*
* @param {Bonus_RewardsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const bonus_rewards = /** @type {((inputs?: Bonus_RewardsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bonus_RewardsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bonus_rewards(inputs)
	if (locale === "ar") return ar_bonus_rewards(inputs)
	if (locale === "de") return de_bonus_rewards(inputs)
	if (locale === "es") return es_bonus_rewards(inputs)
	if (locale === "fr") return fr_bonus_rewards(inputs)
	if (locale === "it") return it_bonus_rewards(inputs)
	if (locale === "ja") return ja_bonus_rewards(inputs)
	if (locale === "ko") return ko_bonus_rewards(inputs)
	if (locale === "pt_br") return pt_br_bonus_rewards(inputs)
	if (locale === "ru") return ru_bonus_rewards(inputs)
	if (locale === "th") return th_bonus_rewards(inputs)
	if (locale === "tr") return tr_bonus_rewards(inputs)
	if (locale === "zh_cn") return zh_cn_bonus_rewards(inputs)
	return zh_tw_bonus_rewards(inputs)
});